/* eslint-disable react/jsx-key */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SnackbarVariant } from '@eas/common-web';
import { MessageType } from './message-type';

const CANCEL_ERROR: MessageType<string> = {
  DECISION_CANCEL_NOT_LAST: [
    <FormattedMessage
      id="ES__MESSAGE__DECISION__CANCEL_NOT_LAST"
      defaultMessage="Stornovat lze pouze poslední aktivní rozhodnutí ve spise."
    />,
    SnackbarVariant.ERROR,
  ],
  DECISION_ALREADY_CANCELED: [
    <FormattedMessage
      id="ES__MESSAGE__DECISION__ALREADY_CANCELED"
      defaultMessage="Rozhodnutí je již stornované."
    />,
    SnackbarVariant.ERROR,
  ],
  DECISION_NOT_LINKED_TO_DOCUMENT: [
    <FormattedMessage
      id="ES__MESSAGE__DECISION__NOT_LINKED_TO_DOCUMENT"
      defaultMessage="Dokument nemá navázané rozhodnutí, které by bylo možné stornovat."
    />,
    SnackbarVariant.ERROR,
  ],
  WRONG_AGENDA: [
    <FormattedMessage
      id="ES__MESSAGE__DECISION__CANCEL_WRONG_AGENDA"
      defaultMessage="Rozhodnutí lze stornovat pouze v agendách Soudní spisy a Stanoviska pléna."
    />,
    SnackbarVariant.ERROR,
  ],
  WRONG_ES_FILE_STATE: [
    <FormattedMessage
      id="ES__MESSAGE__DECISION__CANCEL_WRONG_ES_FILE_STATE"
      defaultMessage="Rozhodnutí nelze stornovat v aktuálním stavu spisu."
    />,
    SnackbarVariant.ERROR,
  ],
};

export default { CANCEL_ERROR };
